<template>
  <div>
    <span class="size-status" style="color:#3fa6f4" v-if="tipoLog == 'info'">
      <v-icon small color="#3fa6f4" class="pb-1 icon-status">mdi-alert-circle-outline</v-icon>Info
    </span>
    <span class="size-status" style="color:green" v-else-if="tipoLog == 'notice'">
      <v-icon small color="green" class="pb-1 icon-status">mdi-magnify</v-icon>Notice
    </span>
    <span class="size-status" style="color:green" v-else-if="tipoLog == 'debug'">
      <v-icon small color="green" class="pb-1 icon-status">mdi-magnify</v-icon>Debug
    </span>
    <span class="size-status" style="color:red" v-else-if="tipoLog == 'critical'">
      <v-icon small color="red" class="pb-1 icon-status">mdi-block-helper</v-icon>Critical
    </span>
    <span class="size-status" style="color:red" v-else-if="tipoLog == 'emergency'">
      <v-icon small color="red" class="pb-1 icon-status">mdi-block-helper</v-icon>Emergency
    </span>

    <span class="size-status" style="color: #e8a633" v-else-if="tipoLog == 'alert'">
      <v-icon small color="#e8a633" class="pb-1 icon-status">mdi-alert</v-icon>Alert
    </span>
    <span class="size-status" style="color: #e8a633" v-else-if="tipoLog == 'warning'">
      <v-icon small color="#e8a633" class="pb-1 icon-status">mdi-alert</v-icon>Warning
    </span>
    <span class="size-status" style="color:red" v-else>
      <v-icon small color="red" class="pb-1 icon-status">mdi-block-helper</v-icon>Error
    </span>
  </div>
</template>

<script>
export default {
  props: {
    tipoLog: {
      type: String,
      required: true
    }
  }
}
</script>
<style>
  .size-status {
    font-size: 0.95rem !important;
    font-weight: normal !important;
  }

  .size-status .v-icon {
    font-size: 0.9rem !important;
  }

  .icon-status{
    margin-right: 1.7px !important;
  }
</style>